import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  SYMBOL_CURRENCY,
  TEXT_ADDONS,
  TEXT_AND,
  TEXT_BEDDING,
  TEXT_CREATE_ORDER,
  TEXT_SHOW_LESS,
  TEXT_SHOW_MORE,
} from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BODY_1_SEMIBOLD,
  STYLE_BODY_1_SEMIBOLD_TH,
  STYLE_BODY_2_SEMIBOLD,
  STYLE_BODY_2_SEMIBOLD_SM,
  STYLE_BODY_2_SEMIBOLD_SM_TH,
  STYLE_BODY_2_SEMIBOLD_TH,
  STYLE_BODY_3_REGULAR,
  STYLE_BODY_3_REGULAR_TEXT_SM,
  STYLE_BUTTON_MYIRON,
  STYLE_BUTTON_MYSHOES,
  STYLE_BUTTON_MYWASH,
  STYLE_HEADING_3,
  STYLE_HEADING_3_TH,
  STYLE_HEADING_4_20,
  STYLE_HEADING_4_20_TH,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PRICE_SIZE,
  STYLE_SIZE_BUTTON_MYIRON,
  STYLE_SIZE_BUTTON_MYSHOES,
  STYLE_SIZE_BUTTON_MYWASH,
  STYLE_SIZE_BUTTON_PRICING,
  STYLE_SIZE_INACTIVE,
  STYLE_SIZE_INACTIVE_PRICING,
  STYLE_TAB_SIZE,
} from "../../../utils/useStyle";
import { BlueButton } from "../../../components/attributes/Button";
import { useNavigate } from "react-router-dom";
import { ICON_DOWN_PRICING, ICON_UP_PRICING } from "../../../utils/useIcons";
import { ContextCart } from "../../../context/Context.Cart";
import { PricingClickToCart } from "../../task/functions/Program.ClickSelectedToCart";

const CardProgram = ({
  color,
  icon,
  programbutton,
  title,
  des,
  price,
  description,
  color_border,
  addons,
  extars,
  size,
  type,
  master,
  master_id,
  self,
  data,
}) => {
  const [showAll, setShowAll] = React.useState(false);
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();

  const { setCart, Storage, cart } = React.useContext(ContextCart);

  // console.log("data", data);

  // const thisAddons = addons?.sort((a, b) => (a.index > b.index ? 1 : -1));
  // const thisAddons = addons;

  return (
    <div className=" w-full h-full mt-8 md:mt-0 ">
      <div className={` flex flex-col ${showAll ? ` md:h-full` : ` `} `}>
        <div className={`relative  rounded-t-2xl  ${color} h-[185px] `}>
          <div
            className={` h-[80px] my-auto  flex justify-center items-center w-full absolute top-6 transform ${
              type === "My Wash" ? "gap-2 px-20" : "gap-4 px-16"
            }`}
          >
            <img
              src={icon}
              className={`${type === "My Wash" ? "w-[70px]" : "w-20 "} `}
            />
            <div
              className={`${
                language === "TH"
                  ? "font-bold text-lg-th md:text-xl-th text-laudry-gray-200 leading-6.5 font-NotoSansThai"
                  : "font-bold text-lg md:text-xl text-laudry-gray-200 leading-6.5 font-Poppins"
              } w-full  `}
            >
              {title}
            </div>
          </div>

          <div
            className={`${STYLE_BODY_3_REGULAR(
              language
            )} text-center mt-6 absolute  left-1/2 transform -translate-x-1/2   top-2/4 w-full px-4  ${
              master?.master_type === "My Iron" ? "w-[250px]  " : ""
            } `}
          >
            {des}
          </div>
        </div>
        <div
          className={`${color_border} border px-4 pt-[20px] md:pt-4 rounded-b-2xl  mb-5 md:mb-0 ${
            showAll ? ` md:h-full` : ` flex-1`
          } `}
        >
          {data?.length > 0 && (
            <dev className="">
              {data
                ?.sort((a, b) => {
                  return a.price - b.price;
                })
                ?.map((row, index) => {
                  return (
                    <div className="pt-5" key={`key-of-index-p-${index}`}>
                      <div className={STYLE_PRICE_SIZE(language)}>
                        <span className="font-NotoSansThai">
                          {SYMBOL_CURRENCY}
                        </span>
                        {row?.price}
                      </div>
                      <div
                        className={` ${
                          language === "TH"
                            ? "font-semibold  text-sm-th md:text-base-th leading-6 font-NotoSansThai"
                            : "font-semibold  text-sm md:text-base leading-6 font-Poppins"
                        } text-laundry-gray-80 text-center  md:mt-2.5`}
                      >
                        {row?.name}
                      </div>
                    </div>
                  );
                })}
            </dev>
          )}
          <div className=" mt-6 md:space-y-2.5 ">
            {/* <div
              className={`${
                language === "TH" ? STYLE_HEADING_4_20_TH : STYLE_HEADING_4_20
              }`}
            >
              {TEXT_ADDONS[language]}
              {type === "My Shoes" ? (
                ""
              ) : (
                <span>
                  <span className={language === "EN" && "mx-1"}>
                    {TEXT_AND[language]}
                  </span>
                  {TEXT_BEDDING[language]}
                </span>
              )}
            </div> */}
            {/* <div
              className={`${
                language === "TH"
                  ? STYLE_BODY_1_SEMIBOLD_TH
                  : STYLE_BODY_1_SEMIBOLD
              } text-laundry-primary-blue py-[10px] md:py-0`}
            >
              {TEXT_ADDONS[language]}
            </div> */}
            {/* {thisAddons
              ?.slice(0, showAll ? thisAddons?.length : 3)
              ?.filter((i) => {
                return i.status === true;
              })
              ?.map((addon) => {
                return (
                  <div
                    key={addon?._id}
                    className=" border-b border-b-laundry-border mb-1.5 pb-[6px] flex justify-between items-start"
                  >
                    <div>
                      <div
                        className={`${
                          language === "TH"
                            ? STYLE_BODY_2_SEMIBOLD_TH
                            : STYLE_BODY_2_SEMIBOLD
                        } text-laundry-gray-100`}
                      >
                        {addon?.name}
                      </div>
                      <div
                        className={`${STYLE_BODY_3_REGULAR_TEXT_SM(
                          language
                        )} mt-1.5 text-laundry-gray-80`}
                      >
                        {addon?.description}
                      </div>
                    </div>
                    <div
                      className={`${
                        language === "TH"
                          ? STYLE_BODY_2_SEMIBOLD_TH
                          : STYLE_BODY_2_SEMIBOLD
                      } text-laundry-gray-100`}
                    >
                      +
                      <span className="font-NotoSansThai">
                        {SYMBOL_CURRENCY}
                      </span>
                      {addon[String(size).toLowerCase()]}
                    </div>
                  </div>
                );
              })} */}
            {/* {showAll && (
              <React.Fragment>
                {extars?.length > 0 && (
                  <div
                    className={`${
                      language === "TH"
                        ? STYLE_BODY_1_SEMIBOLD_TH
                        : STYLE_BODY_1_SEMIBOLD
                    } text-laundry-primary-blue py-[10px] md:py-0`}
                  >
                    {TEXT_BEDDING[language]}
                  </div>
                )}
                {extars?.length > 0 &&
                  extars
                    ?.filter((i) => {
                      return i.status === true;
                    })
                    ?.sort((a, b) => {
                      return a.index - b.index;
                    })
                    ?.map((addon) => {
                      return (
                        <div
                          key={addon?._id}
                          className=" border-b border-b-laundry-border mb-1.5 pb-1.5 flex justify-between "
                        >
                          <div>
                            <div
                              className={`${
                                language === "TH"
                                  ? STYLE_BODY_2_SEMIBOLD_TH
                                  : STYLE_BODY_2_SEMIBOLD
                              } text-laundry-gray-100`}
                            >
                              {addon?.name}
                            </div>
                            <div
                              className={`${STYLE_BODY_3_REGULAR_TEXT_SM(
                                language
                              )} mt-1.5 text-laundry-gray-80`}
                            >
                              {addon?.description}
                            </div>
                          </div>
                          <div
                            className={`${
                              language === "TH"
                                ? STYLE_BODY_2_SEMIBOLD_TH
                                : STYLE_BODY_2_SEMIBOLD
                            } text-laundry-gray-100`}
                          >
                            +
                            <span className="font-NotoSansThai">
                              {SYMBOL_CURRENCY}
                            </span>
                            {addon?.price}
                          </div>
                        </div>
                      );
                    })}
              </React.Fragment>
            )} */}
          </div>
          {/* {type !== "My Shoes" && (
            <div
              onClick={() => {
                setShowAll(!showAll);
              }}
              className={`  ${
                language === "TH" ? " text-sm " : " text-xs "
              } text-center  pt-[20px] w-fit mx-auto `}
            >
              {showAll ? (
                <div
                  onClick={() => {
                    const findSelfDiv = document.getElementById(
                      "pricing_scroll_ja_haha_plus"
                    );
                    findSelfDiv?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                    });
                  }}
                  className={`flex gap-2 items-center justify-center linkblue w-fit mx-auto text-tiny `}
                >
                  {TEXT_SHOW_LESS[language]}
                </div>
              ) : (
                <div
                  className={` flex gap-2 items-center justify-center w-fit mx-auto linkblue  text-tiny `}
                >
                  {TEXT_SHOW_MORE[language]}
                </div>
              )}
            </div>
          )} */}
        </div>
      </div>
      <div className={` md:mt-6.5`}>
        <BlueButton
          className={programbutton}
          title={TEXT_CREATE_ORDER[language]}
          onClick={() => {
            if (type === "My Wash") {
              // sessionStorage.setItem("program", master?.master_type);
              // sessionStorage.setItem("program_id", master_id);
              // sessionStorage.setItem("pricingSize", size);

              PricingClickToCart({
                size,
                master,
                master_id,
                cart,
                setCart,
                navigate,
                self,
                Storage,
                setCart,
                type,
              });
              // navigate("/MyWash");
            }
            if (type === "My Iron") {
              PricingClickToCart({
                size,
                master,
                master_id,
                cart,
                setCart,
                navigate,
                self,
                Storage,
                setCart,
                type,
              });
              // navigate("/MyIron");

              // sessionStorage.setItem("program", master?.master_type);
              // sessionStorage.setItem("program_id", master_id);
              // sessionStorage.setItem("pricingSize", size);
            }
            if (type === "My Shoes") {
              PricingClickToCart({
                size,
                master,
                master_id,
                cart,
                setCart,
                navigate,
                self,
                Storage,
                setCart,
                type,
              });
              // navigate("/MyShoes");

              // sessionStorage.setItem("program", master?.master_type);
              // sessionStorage.setItem("program_id", master_id);
              // sessionStorage.setItem("pricingSize", size);
            }

            // navigate("/Program");
          }}
        />
      </div>
    </div>
  );
};

const mapping = {
  S: "Option 1",
  M: "Option 2",
  L: "Option 3",
};

const TabSize = ({ value, setValue, tab = [], program_type }) => {
  const { language } = React.useContext(ContextLanguage);
  return (
    <div>
      <div className={STYLE_TAB_SIZE}>
        {tab?.map((item, index) => {
          return (
            <div key={`key-of-tab-${index}`} className=" cursor-pointer ">
              <div
                onClick={() => {
                  if (value === item) {
                    // setValue("");
                  } else {
                    setValue(item);
                  }
                }}
              >
                <div
                  className={
                    value === item
                      ? program_type
                      : STYLE_SIZE_INACTIVE_PRICING(language)
                  }
                >
                  <React.Fragment>{mapping[item]}</React.Fragment>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export const FunctionSort = (data, sort = [0, 2, 1]) => {
  let newData = data?.map((row, index) => {
    return {
      ...row,
      sort: sort[index],
    };
  });

  newData = newData?.sort((a, b) => {
    return Number(a?.index) - Number(b?.index);
  });

  return newData;
};

const ProgramDesktop = React.memo(({ programs, addons: thisAddons }) => {
  const [state, setState] = React.useState("S");

  const { language } = React.useContext(ContextLanguage);

  return (
    <div id="pricing_scroll_ja_haha_plus" className=" ">
      {/* <TabSize
        value={state}
        setValue={setState}
        tab={["S", "M", "L"]}
        program_type={STYLE_SIZE_BUTTON_PRICING(language)}
      /> */}
      <div className=" block md:flex  gap-13.5 md:gap-3.5 md:mt-6.5 ">
        {FunctionSort(programs, [0, 1, 2])?.map((program) => {
          const isMyWashe = program?.master_type === "My Wash";
          const isMyShoes = program?.master_type === "My Shoes";
          const isMyIron = program?.master_type === "My Iron";

          // const self = thisAddons?.addons?.find((addon) => {
          //   return (
          //     addon?.size === state &&
          //     addon?.type === "PACKAGE" &&
          //     addon?.master_id === program?._id
          //   );
          // });

          // const addons = thisAddons?.addons?.filter((addon) => {
          //   return addon?.type === "ADDON" && addon?.master_id === program?._id;
          // });

          // const extars = thisAddons?.addons?.filter((addon) => {
          //   return addon?.type === "EXTRA" && addon?.master_id === program?._id;
          // });

          const isMine = thisAddons?.addons?.filter((addon) => {
            return (
              addon?.master_id === program?._id && addon?.type === "PACKAGE"
            );
          });

          return (
            <CardProgram
              key={program?._id}
              color={
                isMyWashe
                  ? " bg-laundry-mywash "
                  : isMyShoes
                  ? " bg-laundry-myshoes "
                  : isMyIron
                  ? " bg-laundry-myiron "
                  : ""
              }
              color_border={
                isMyWashe
                  ? " border-laundry-mywash "
                  : isMyShoes
                  ? " border-laundry-myshoes "
                  : isMyIron
                  ? " border-laundry-myiron "
                  : ""
              }
              icon={
                isMyWashe
                  ? "/icons/mywash_white.svg"
                  : isMyShoes
                  ? "/icons/shoes_white.svg"
                  : isMyIron
                  ? "/icons/iron_white.png"
                  : ""
              }
              title={program?.name}
              type={program?.master_type}
              des={program?.description}
              data={isMine}
              // price={self?.price}
              // description={self?.name}
              programbutton={
                isMyWashe
                  ? STYLE_BUTTON_MYWASH(language)
                  : isMyShoes
                  ? STYLE_BUTTON_MYSHOES(language)
                  : isMyIron
                  ? STYLE_BUTTON_MYIRON(language)
                  : ""
              }
              // addons={addons}
              // extars={extars}
              size={state}
              master_id={program?._id}
              master={program}
              // self={self}
            />
          );
        })}
      </div>
    </div>
  );
});

const RenderEachMobileProgram = ({
  program,
  isMyWashe,
  isMyShoes,
  isMyIron,
  extars,
  addons,
  thisAddons,
}) => {
  const [state, setState] = React.useState("S");
  const { cart } = React.useContext(ContextCart);

  const self = thisAddons?.find((addon) => {
    return addon?.size === state && addon?.type === "PACKAGE";
  });

  // React.useEffect(() => {
  //   if (cart?.length > 0) {
  //     const findSelfCurrentSize = cart?.find((item) => {
  //       return item?.master_id === program?._id && item?.type === "PACKAGE";
  //     });

  //     if (findSelfCurrentSize?.size) {
  //       setState(findSelfCurrentSize?.size);
  //     }
  //     // setState(findSelfCurrentSize?.size);
  //   }
  // }, [cart]);

  const { language } = React.useContext(ContextLanguage);

  return (
    <div>
      {/* <TabSize
        value={state}
        setValue={setState}
        tab={["S", "M", "L"]}
        program_type={
          isMyWashe
            ? STYLE_SIZE_BUTTON_MYWASH(language)
            : isMyShoes
            ? STYLE_SIZE_BUTTON_MYSHOES(language)
            : isMyIron
            ? STYLE_SIZE_BUTTON_MYIRON(language)
            : STYLE_SIZE_INACTIVE(language)
        }
      /> */}
      <CardProgram
        self={self}
        key={program?._id}
        color={
          isMyWashe
            ? " bg-laundry-mywash "
            : isMyShoes
            ? " bg-laundry-myshoes "
            : isMyIron
            ? " bg-laundry-myiron "
            : ""
        }
        color_border={
          isMyWashe
            ? " border-laundry-mywash "
            : isMyShoes
            ? " border-laundry-myshoes "
            : isMyIron
            ? " border-laundry-myiron "
            : ""
        }
        icon={
          isMyWashe
            ? "/icons/mywash_white.svg"
            : isMyShoes
            ? "/icons/shoes_white.svg"
            : isMyIron
            ? "/icons/iron_white.svg"
            : ""
        }
        title={
          isMyWashe
            ? "My Wash"
            : isMyShoes
            ? "My Shoes"
            : isMyIron
            ? "My Iron"
            : ""
        }
        type={program?.master_type}
        des={program?.description}
        price={self?.price}
        description={self?.name}
        programbutton={
          isMyWashe
            ? STYLE_BUTTON_MYWASH(language)
            : isMyShoes
            ? STYLE_BUTTON_MYSHOES(language)
            : isMyIron
            ? STYLE_BUTTON_MYIRON(language)
            : ""
        }
        addons={addons}
        extars={extars}
        size={state}
        master_id={program?._id}
        master={program}
      />
    </div>
  );
};

const ProgramMobile = React.memo(({ programs, state, addons }) => {
  return (
    <div>
      <div className=" grid grid-cols-1 gap-13.5 ">
        {FunctionSort(programs, [0, 2, 1])?.map((program) => {
          const isMyWashe = program?.master_type === "My Wash";
          const isMyShoes = program?.master_type === "My Shoes";
          const isMyIron = program?.master_type === "My Iron";

          const thisAddons = addons?.addons?.filter((addon) => {
            return addon?.master_id === program?._id;
          });

          // return (
          //   <Page
          //     renderLoading={<React.Fragment />}
          //     api={api}
          //     path="/addons"
          //     params={{ language: language, master_id: program?._id }}
          //     renderBody={({ data }) => {
          // console.log("thisAddons", { thisAddons });
          // const self = thisAddons?.find((addon) => {
          //   return addon?.size === state && addon?.type === "PACKAGE";
          // });

          // console.log("self", self);

          // const self = thisAddons?.addons?.find((addon) => {
          //   return (
          //     addon?.size === state &&
          //     addon?.type === "PACKAGE" &&
          //     addon?.master_id === program?._id
          //   );
          // });

          const addonM = thisAddons?.filter((addon) => {
            return addon?.type === "ADDON";
          });

          const extars = thisAddons?.filter((addon) => {
            return addon?.type === "EXTRA";
          });

          return (
            <RenderEachMobileProgram
              isMyIron={isMyIron}
              isMyShoes={isMyShoes}
              isMyWashe={isMyWashe}
              program={program}
              addons={addonM}
              extars={extars}
              thisAddons={thisAddons}
              // self={self}
            />
          );
          // }
          // }
          // />
          // );
        })}
      </div>
    </div>
  );
});

const RenderMain = ({ programs, addons }) => {
  const isMobile = useIsMobile();

  return (
    <div
      className={` mb-13.5 px-4 md:px-10 xl:px-37  h-full ${STYLE_MAX_WIDTH_DESKTOP} `}
    >
      <ProgramDesktop programs={programs} addons={addons} />
      {/* {isMobile ? (
        <ProgramMobile programs={programs} addons={addons} />
      ) : (
        <ProgramDesktop programs={programs} addons={addons} />
      )} */}
    </div>
  );
};

export const PricingSize = React.memo(({ programs, addons }) => {
  if (programs?.length > 0) {
    return <RenderMain programs={programs} addons={addons} />;
  } else {
    return <React.Fragment />;
  }
});
